import React from 'react';
import { Helmet } from 'react-helmet';

import ContentWrapper from '../styles/ContentWrapper';

const Imprint = () => (
    <React.Fragment>
        <Helmet>
            <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <article
            about='/legal/imprint'
            typeof='schema:WebPage'
        >
            <ContentWrapper>
                <span
                    property='schema:name'
                    content='Impressum'
                    className='stolo-hidden'
                />
                <div
                    property='schema:text'
                    className='clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item'
                >
                    <h2>Impressum</h2>
                    <p>
                        <br />
                        <br />
                        Becker &amp; Karsten UG (haftungsbeschränkt)
                        <br />
                        Sandhauser Strasse 107
                        <br />
                        13505 Berlin
                        <br />
                        (kein Ladengeschäft)
                        <br />
                        <br />
                        <a href='mailto: wir@stoff.love'>wir@stoff.love</a>
                        <br />
                        <br />
                        Telefon: +49 30 609851965
                        <br />
                        <br />
                        vertreten durch:
                        <br />
                        Olaf Karsten (Geschäftsführer)
                        <br />
                        Sandhauser Strasse 107
                        <br />
                        13505 Berlin
                        <br />
                        <br />
                        <a href='mailto: wir@stoff.love'>wir@stoff.love</a>
                        <br />
                        <br />
                        Telefon: (030) 609851965
                    </p>

                    <p>
                        Verantwortlich für den Datenschutz:
                        <br />
                        Olaf Karsten
                        <br />
                        Anschrift wie oben
                        <br />
                        <br />
                        E-Mail:
                        {' '}
                        <a
                            className='buk-mail'
                            href='mailto:datenschutz@beckerundkarsten.de'
                        >
                            datenschutz@beckerundkarsten.de
                        </a>
                    </p>

                    <p>
                        <a href='/legal/privacy'>Unsere Datenschutzerklärung.</a>
                    </p>

                    <p>
                        E-Mail:&nbsp;
                        <a href='mailto: wir@stoff.love'>wir@stoff.love</a>
                        <br />
                        <br />
                        Registergericht: Berlin Charlottenburg
                        <br />
                        Registernummer: HRB 120030
                        <br />
                        Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:
                        <br />
                        UST-ID: DE265138737
                        <br />
                        <br />
                        Verantwortliche/r i.S.d. &sect; 18 Abs. 2 MStV:<br />
                        Olaf Karsten, Standhauser Str. 107, 13505 Berlin<br />
                        <br />
                        Zust&auml;ndige Aufsichtsbeh&ouml;rde f&uuml;r das Angebot audiovisueller Mediendienste:<br />
                        Medienanstalt Berlin-Brandenburg (mabb), Kleine Pr&auml;sidentenstra&szlig;e 1, 10178 Berlin, Deutschland<br />
                        <br />
                        Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet, hierzu jedoch bereit.<br />
                        <br />
                    </p>
                </div>
            </ContentWrapper>
        </article>
    </React.Fragment>
);

export default Imprint;



// WEBPACK FOOTER //
// ./src/components/de/Imprint.js